// Prevent scroll when page loads with form anchor hash (after Shopify form submission)
(function() {
  if (window.location.hash === '#form__popup_newsletter' ||
      window.location.search.includes('customer_posted=true')) {
    // Scroll to top immediately
    window.scrollTo(0, 0);

    // Remove the hash and query params from URL without reload
    if (history.replaceState) {
      history.replaceState(null, null, window.location.pathname);
    }

    // Also prevent any delayed scroll attempts
    requestAnimationFrame(() => {
      window.scrollTo(0, 0);
    });
  }
})();

function checkScrollbar() {
    const rect = document.body.getBoundingClientRect();
    return Math.round(rect.left + rect.right) < window.innerWidth;
}
function setScrollbarWidth() {
    if (checkScrollbar()) {
      const element = document.createElement('span');
      element.className = 'modal-scrollbar-measure', document.body.appendChild(element);
    
      const width = element.getBoundingClientRect().width - element.clientWidth;
      document.body.removeChild(element);
      document.documentElement.style.setProperty('--scrollbar-width', `${width}px`);
    }
}

function filterShopifyEvent(event, domElement, callback) {
    let executeCallback = false;
    if (event.type.includes('shopify:section')) {
      if (domElement.hasAttribute('data-section-id') && domElement.getAttribute('data-section-id') === event.detail.sectionId) {
        executeCallback = true;
      }
    }
    else if (event.type.includes('shopify:block') && event.target === domElement) {
      executeCallback = true;
    }
    if (executeCallback) {
      callback(event);
    }
  }

  

class SocialFloating extends HTMLElement {
    constructor() {
      super();
  
      // Prevent popup on Shopify robot challenge page
      if (window.location.pathname === '/challenge') {
        return;
      }
  
      this.classes = {
        activeClass: 'is-active',
        closingClass: 'is-closing'
      };
  
      this.querySelectorAll('[data-social-toggle]').forEach((button) => {
        button.addEventListener('click', this.onButtonClick.bind(this));
      });
    }
  
    onButtonClick(event) {
      event.preventDefault();
    //   if (!theme.config.mqlSmall) return;
  
      this.classList.contains(this.classes.activeClass) ? this.close() : this.open();
    }
  
    open() {
      this.classList.add(this.classes.activeClass);
  
      // close promo-popup
      const popup = document.querySelector('promo-popup');
      popup && popup.close();
    }
  
    close() {
      this.classList.add(this.classes.closingClass);
  
      setTimeout(() => {
        this.classList.remove(this.classes.activeClass);
        this.classList.remove(this.classes.closingClass);
      }, 500);
    }
  }
  customElements.define('social-floating', SocialFloating);
  
 class PromoPopup extends HTMLElement {
  constructor() {
    super();

    // Prevent popup on Shopify robot challenge page
    if (window.location.pathname === '/challenge') {
      return;
    }

    this.cookieName = 'beyours:promo-popup';
    this.classes = {
      bodyClass: 'promo-popup--open',
      activeClass: 'is-active',
      closingClass: 'is-closing',
      showImage: 'show-image'
    };
    this.popup = this.querySelector('.promo-popup');
    
    // Reference to form
    var popupForm = document.getElementById("form__popup_newsletter");

    popupForm.addEventListener("submit", (event) => {
      event.preventDefault();

      const formData = new FormData(event.target);
      const formDataJSON = {};
      formData.forEach((value, key) => {
        formDataJSON[key] = value;
      });

      // Retrieve previously stored form data from localStorage
      const storedFormData = JSON.parse(localStorage.getItem("newsletterFormData"));
      const currentTime = new Date().getTime();
      const thirtyDays = 30 * 24 * 60 * 60 * 1000; // 30 days in milliseconds

      // Check if stored data exists and compare the values
      if (storedFormData && storedFormData.data && storedFormData.timestamp) {
        const timeElapsed = currentTime - storedFormData.timestamp;
        if (storedFormData.data['contact[email]'] === formDataJSON['contact[email]'] &&
            timeElapsed < thirtyDays) {
          // Show a message in the popup that says the data has already been submitted within 30 days
          this.showMessage('You have already submitted this information. Please try again after 30 days.');
          return;
        }
      }

      // Save the new form data along with the current timestamp
      localStorage.setItem("newsletterFormData", JSON.stringify({
        data: formDataJSON,
        timestamp: currentTime
      }));

      // Handle successful submission (you can trigger your API call here)
      this.setCookie(this.cookieName, this.dataset.expiry);
    });

    // Load form data if available on page load
    document.addEventListener("DOMContentLoaded", () => {
      const storedFormData = localStorage.getItem("newsletterFormData");
      if (storedFormData) {
        const formData = JSON.parse(storedFormData).data;
        var phone = formData['contact[phone]'];
        var email = formData['contact[email]'];
        var source = 'My Integration';
        window.smsBumpSubscribe(phone, email, source);
        this.setCookie(this.cookieName, this.dataset.expiry);
      }
    });

    // Open modal if there are any form messages
    if (this.querySelector('.form__message')) {
      this.open();
    }

    // Attach event listeners to popup toggle buttons
    this.querySelectorAll('[data-popup-toggle]').forEach((button) => {
      button.addEventListener('click', this.onButtonClick.bind(this));
    });

    // Initialize popup if no cookie is set or in test mode
    if (!this.getCookie(this.cookieName) || this.dataset.testMode === 'true') {
      this.init();
    }
  }

  // Method to show a message in the popup
  showMessage(message) {
    const messageElement = this.querySelector('.form__message');
    if (messageElement) {
      messageElement.textContent = message;
      messageElement.classList.add(this.classes.activeClass);
    }
  }

  // Initialize popup with a delay
  init() {
    if (Shopify && Shopify.designMode) {
      return;
    }

    setTimeout(() => {
      this.open();
    }, parseInt(this.dataset.delay) * 1000);
  }

  // Handle button click to open or close popup
  onButtonClick(event) {
    event.preventDefault();
    this.popup.classList.contains(this.classes.activeClass) ? this.close() : this.open();
  }

  // Open popup
  open() {
    document.body.classList.add(this.classes.bodyClass);
    this.popup.classList.add(this.classes.activeClass);
    setTimeout(() => {
      this.popup.classList.add(this.classes.showImage);
    }, 600);

    if (this.popup.dataset.position === 'center') {
      setScrollbarWidth();
      document.body.classList.add(this.classes.bodyClass);
    }

    // Close social-floating if present
    const social = document.querySelector('social-floating');
    social && social.close();
  }

  // Close popup
  close() {
    this.popup.classList.add(this.classes.closingClass);

    setTimeout(() => {
      this.popup.classList.remove(this.classes.activeClass);
      this.popup.classList.remove(this.classes.closingClass);
      this.popup.classList.remove(this.classes.showImage);

      if (this.popup.dataset.position === 'center') {
        document.body.classList.remove(this.classes.bodyClass);
      }
    }, 500);

    // Remove the cookie if in test mode
    if (this.dataset.testMode === 'true') {
      this.removeCookie(this.cookieName);
      return;
    }

    // Set cookie to prevent popup from showing again for the specified expiry time
    this.setCookie(this.cookieName, this.dataset.expiry);
  }

  // Utility method to get a cookie
  getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  // Utility method to set a cookie
  setCookie(name, expiry) {
    document.cookie = `${name}=true; max-age=${(expiry * 24 * 60 * 60)}; path=/`;
  }

  // Utility method to remove a cookie
  removeCookie(name) {
    document.cookie = `${name}=; max-age=0; path=/`;
  }
}

customElements.define('promo-popup', PromoPopup);

  